import { hashCode } from "src/components/js/statics1";

export default class vehicleClass {
  constructor(vehicleId) {
    this.vehicleId = vehicleId;
    this.asiakasId = null;
    this.firstDate = null;
    this.lastDate = null;
    this.foreignKey = null;
    this.vehicleNimi = null;
    this.vehicleNo = null;
    this.vehiclePuomi = null;
    this.vehicleRegNo = null;
    this.vehicleTypeId = null;
    this.vehicleTypeName = null;
    this.vehicleTypeShortName = null;
    this.isLoaded = false;
    this.sortNo = 0; // sort order for vehicle list
    this.showInGrid = true; // show vehicle in grid
    // other to be added
    this.defaultKuski_personId; // default driver/pumppari
    this.tuoteId; // default product
    this.tuoteNimike; // default product name
  }

  get vehicleString() {
    return (this.vehicleNo > 0 ? this.vehicleNo + " " : "") + this.vehicleRegNo;
  }
  get vehicleHash() {
    return hashCode(JSON.stringify(this));
  }
  static vehicleText(vehicle) {
    if (!vehicle) return "";
    return vehicle.vehicleNimi?.length > 2 ? vehicle.vehicleNimi : vehicle.vehicleRegNo;
  }
}
